import {atom} from "jotai";
import {atomWithStorage} from "jotai/utils";
import {Company} from "../types/domain/company";
import {Order} from "../types/domain/order";
import {routerCompanyIdAtom, routerFarmIdAtom, routerFieldIdAtom} from "./routerStore";

type EntityType = "company" | "farm" | "field";

export const selectedEntityAtom = atom<{entityType: EntityType; entityId: string} | null>((get) => {
    const routerCompanyId = get(routerCompanyIdAtom);
    const routerFarmId = get(routerFarmIdAtom);
    const routerFieldId = get(routerFieldIdAtom);

    if (routerFieldId) {
        return {
            entityType: "field",
            entityId: routerFieldId,
        };
    } else if (routerFarmId) {
        return {
            entityType: "farm",
            entityId: routerFarmId,
        };
    } else if (routerCompanyId) {
        return {
            entityType: "company",
            entityId: routerCompanyId,
        };
    } else {
        return null;
    }
});
selectedEntityAtom.debugLabel = "selectedEntity";

export const selectedCompanyAtom = atom<Company | null>(null);

export const selectedOrderAtom = atom<Order | null>(null);

const LOCAL_STORAGE_SHOW_ACTIVE_FIELDS_KEY = "showActiveFields";

export const showActiveFieldsAtom = atomWithStorage<boolean>(LOCAL_STORAGE_SHOW_ACTIVE_FIELDS_KEY, false);
